import React, { useEffect } from "react"
import {
  Badge,
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Spinner,
  Table,
} from "reactstrap"
import { useDispatch, useSelector } from "react-redux"
import { useNavigate } from "react-router-dom"
import { useTranslation } from "react-i18next"
import Breadcrumbs from "components/Common/Breadcrumb"
import { getAllInvoices } from "store/actions/subscriptionAction"
import { ROUTES } from "constants/routes"
import "./billing.scss"
import { getCurrencyLabel } from "utils/currency"

const statusColors = {
  paid: "success",
  pending: "warning",
  failed: "danger",
  cancelled: "secondary",
}

const Invoices = () => {
  const { t } = useTranslation()
  document.title = t("Invoices ")

  const dispatch = useDispatch()
  const navigate = useNavigate()

  const { invoicesLoading, invoices, currentPage, itemsPerPage } = useSelector(
    state => state.Subscription
  )

  useEffect(() => {
    dispatch(
      getAllInvoices({ page: currentPage, limit: itemsPerPage })
    )
  }, [dispatch, currentPage, itemsPerPage])

  const handleViewDetails = invoice => {
    navigate(`${ROUTES.BILLING_INVOICE_DETAILS}?id=${invoice._id}`)
  }

  const formatDate = dateStr => {
    if (!dateStr) return "-"
    return new Date(dateStr).toLocaleDateString()
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs />
          <h4 className="mb-4">{t("Invoices")}</h4>

          <Card>
            <CardBody>
              {invoicesLoading ? (
                <div className="text-center py-5">
                  <Spinner color="primary" />
                </div>
              ) : invoices.length === 0 ? (
                <div className="text-center py-5 text-muted">
                  {t("No invoices found.")}
                </div>
              ) : (
                <div className="table-responsive">
                  <Table className="table-hover align-middle mb-0">
                    <thead className="table-light">
                      <tr>
                        <th>{t("#")}</th>
                        <th>{t("Invoice No.")}</th>
                        <th>{t("Plan")}</th>
                        <th>{t("Amount")}</th>
                        <th>{t("Status")}</th>
                        <th>{t("Date")}</th>
                        <th>{t("Actions")}</th>
                      </tr>
                    </thead>
                    <tbody>
                      {invoices.map((inv, idx) => (
                        <tr key={inv._id || idx}>
                          <td>
                            {(currentPage - 1) * itemsPerPage + idx + 1}
                          </td>
                          <td className="fw-semibold">
                            {inv.invoiceNumber || inv._id || "-"}
                          </td>
                          <td>{inv.planName || inv.plan?.name || inv.metadata?.planName || "-"}</td>
                          <td className="invoice-amount">
                            {getCurrencyLabel(inv.currency || "SAR")}{" "}
                            {Number(inv.amount || 0).toFixed(2)}
                          </td>
                          <td>
                            <Badge
                              color={
                                statusColors[inv.status?.toLowerCase()] ||
                                "secondary"
                              }
                            >
                              {inv.status || "-"}
                            </Badge>
                          </td>
                          <td>{formatDate(inv.createdAt || inv.date)}</td>
                          <td>
                            <Button
                              color="primary"
                              size="sm"
                              outline
                              onClick={() => handleViewDetails(inv)}
                            >
                              {t("View")}
                            </Button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </div>
              )}
            </CardBody>
          </Card>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default Invoices
